import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

const SUPABASE_URL = "https://vmxlycmybdsojsworyal.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZteGx5Y215YmRzb2pzd29yeWFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ5NTQwODksImV4cCI6MjA5MDUzMDA4OX0.kU9bot98VWZu4gsb6Yki4Pw1961EXlp3GWZjg3UeJfA";

// PKCE : nécessaire pour que le retour OAuth via deep link (mendescut://) puisse
// être échangé contre une session dans la webview de l'app native.
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: { flowType: 'pkce', detectSessionInUrl: true },
});

// Seul le compte du salon (email/mot de passe SANS role "client") est admin.
// Les comptes clients créés dans l'app portent user_metadata.role = 'client'.
export function isAdminSession(s) {
  return s?.user?.app_metadata?.provider === 'email' && s?.user?.user_metadata?.role !== 'client';
}

// Login Google unifié web + natif.
// Web : redirection classique vers l'origine.
// Natif : navigateur système + retour dans l'app via mendescut://auth-callback
// (schéma déclaré dans Info.plist, URL autorisée dans Supabase → URL Configuration).
export async function signInWithGoogle() {
  const native = Capacitor.isNativePlatform();
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: native ? 'mendescut://auth-callback' : window.location.origin,
      skipBrowserRedirect: native,
    },
  });
  if (error) return { error };
  if (native && data?.url) await Browser.open({ url: data.url });
  return { error: null };
}
